<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose" :maskClosable="false">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="用户ID｛zb_user.id｝" prop="userId" >
        <a-input v-model="form.userId" placeholder="请输入用户ID｛zb_user.id｝" />
      </a-form-model-item>
      <a-form-model-item label="类型 1-ai择医 2-自主择医 3-人工择医" prop="type" >
      </a-form-model-item>
      <a-form-model-item label="择医范围 1-市 2-省 3-全国" prop="range" >
        <a-input v-model="form.range" placeholder="请输入择医范围 1-市 2-省 3-全国" />
      </a-form-model-item>
      <a-form-model-item label="省/市ID｛sys_area.id｝" prop="cityProvince" >
        <a-input v-model="form.cityProvince" placeholder="请输入省/市ID｛sys_area.id｝" />
      </a-form-model-item>
      <a-form-model-item label="患者姓名" prop="name" >
        <a-input v-model="form.name" placeholder="请输入患者姓名" />
      </a-form-model-item>
      <a-form-model-item label="患者类型 1-儿童 2-成人" prop="patientType" >
      </a-form-model-item>
      <a-form-model-item label="性别 1-男 2-女" prop="sex" >
      </a-form-model-item>
      <a-form-model-item label="需要医师数量" prop="doctorNum" >
        <a-input v-model="form.doctorNum" placeholder="请输入需要医师数量" />
      </a-form-model-item>
      <a-form-model-item label="医币数" prop="price" >
        <a-input v-model="form.price" placeholder="请输入医币数" />
      </a-form-model-item>
      <a-form-model-item label="积分数" prop="score" >
        <a-input v-model="form.score" placeholder="请输入积分数" />
      </a-form-model-item>
      <a-form-model-item label="疾病ID｛zb_illness.id｝" prop="illnessId" >
        <a-input v-model="form.illnessId" placeholder="请输入疾病ID｛zb_illness.id｝" />
      </a-form-model-item>
      <a-form-model-item label="状态 0-待支付 1-已支付" prop="status" >
      </a-form-model-item>
      <a-form-model-item label="支付方式 1-微信 2-支付宝" prop="payType" >
      </a-form-model-item>
      <a-form-model-item label="支付时间" prop="payTime" >
        <a-date-picker style="width: 100%" v-model="form.payTime" format="YYYY-MM-DD HH:mm:ss" allow-clear/>
      </a-form-model-item>
      <a-form-model-item label="是否分配 0-否 1-是" prop="isAllot" >
        <a-input v-model="form.isAllot" placeholder="请输入是否分配 0-否 1-是" />
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark" >
        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
<!--          <a-button type="primary" :loading="submitLoading" @click="submitForm">-->
<!--            保存-->
<!--          </a-button>-->
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getChoose, addChoose, updateChoose } from '@/api/user/choose'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        userId: null,

        type: null,

        range: null,

        cityProvince: null,

        name: null,

        patientType: null,

        sex: null,

        doctorNum: null,

        price: null,

        score: null,

        illnessId: null,

        status: 0,

        payType: null,

        payTime: null,

        isAllot: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        userId: [
          { required: true, message: '用户ID｛zb_user.id｝不能为空', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '类型 1-ai择医 2-自主择医 3-人工择医不能为空', trigger: 'change' }
        ],
        range: [
          { required: true, message: '择医范围 1-市 2-省 3-全国不能为空', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '患者姓名不能为空', trigger: 'blur' }
        ],
        patientType: [
          { required: true, message: '患者类型 1-儿童 2-成人不能为空', trigger: 'change' }
        ],
        sex: [
          { required: true, message: '性别 1-男 2-女不能为空', trigger: 'change' }
        ],
        doctorNum: [
          { required: true, message: '需要医师数量不能为空', trigger: 'blur' }
        ],
        price: [
          { required: true, message: '医币数不能为空', trigger: 'blur' }
        ],
        illnessId: [
          { required: true, message: '疾病ID｛zb_illness.id｝不能为空', trigger: 'blur' }
        ],
        status: [
          { required: true, message: '状态 0-待支付 1-已支付不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        userId: null,
        type: null,
        range: null,
        cityProvince: null,
        name: null,
        patientType: null,
        sex: null,
        doctorNum: null,
        price: null,
        score: null,
        illnessId: null,
        status: 0,
        payType: null,
        payTime: null,
        isAllot: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getChoose({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    handleInfo(row){
      this.reset()
      this.formType = 2
      getChoose({"id":row.id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '详情'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateChoose(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addChoose(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
